<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../rds/TableExpand.vue";
var tableDataVue = {};
export default {
  name: "TableRelationalDatabaseServiceResourceGcp",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row,
              },
            });
          },
        },
        {
          title: this.$t("RAM.ALI.database.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.ALI.database.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.ALI.database.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.GCP.RelationalDataBaseResource.name"),
          key: "name",
        },
        {
          title: this.$t("RAM.GCP.RelationalDataBaseResource.endpoint"),
          key: "endpoint",
        },
        {
          title: this.$t("RAM.ALI.database.engine"),
          key: "engine",
        },
        {
          title: this.$t("RAM.GCP.RelationalDataBaseResource.type"),
          key: "type",
        },

        {
          title: this.$t("RAM.ALI.database.storageSize"),
          key: "allocatedStorage",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("name", function (val) {
      tableDataVue.name = val;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {

      this.$api.resourceManagement
        .selectGCPCloudSQLByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          name: tableDataVue.name,
          accountType: 4,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function () {
      eventBus.$off("companyId");
      eventBus.$off("accountName");
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/rds/TableRelationalDatabaseServiceResourceGcp.vue